module.exports = __webpack_public_path__ + "static/media/validacao_url_dark.2bd40ab9.svg";